export type Sample = { t: number; x: number }

const FRAME = 1000 / 60
const RUBBER = 0.55
const DECELERATION = 0.998

export const rubberBand = (offset: number, dimension: number) => {
  const sign = Math.sign(offset)
  const abs = Math.abs(offset)
  return sign * (1 - 1 / ((abs * RUBBER) / dimension + 1)) * dimension
}

export const velocityOf = (samples: readonly Sample[]) => {
  const last = samples.at(-1)
  if (!last) return 0
  const first = samples.find((s) => last.t - s.t <= 100) ?? last
  const dt = last.t - first.t
  return dt > 0 ? (last.x - first.x) / dt : 0
}

export const project = (offset: number, velocity: number) => offset + (velocity * DECELERATION) / (1 - DECELERATION)

export function springFrames(from: number, to: number, velocity: number, response = 0.38) {
  const omega = (2 * Math.PI) / response
  const x0 = from - to
  const v0 = velocity * 1000
  const frames: number[] = []
  for (let i = 0; i < 90; i += 1) {
    const t = (i * FRAME) / 1000
    const decay = Math.exp(-omega * t)
    const x = (x0 + (v0 + omega * x0) * t) * decay
    frames.push(to + x)
    const speed = Math.abs((v0 - omega * (v0 + omega * x0) * t) * decay)
    if (i > 2 && Math.abs(x) < 0.4 && speed < 20) break
  }
  frames.push(to)
  return { frames, duration: (frames.length - 1) * FRAME }
}
